export default __webpack_public_path__ + "static/media/landingSurvey.9d72bdf4.png";